import Reveal from "@/components/base/Reveal";
import SectionTag from "@/components/base/SectionTag";
import { leadTypes } from "@/mocks/content";

export default function LeadTypesSection() {
  return (
    <section className="w-full bg-background-50 py-20 md:py-28" id="lead-types">
      <div className="mx-auto w-full max-w-[1320px] px-5 md:px-8">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <SectionTag tone="primary">什么值得爆料</SectionTag>
            <h2 className="mt-5 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
              六类线索，我们最需要
            </h2>
            <p className="mt-4 text-sm leading-7 text-foreground-600 md:text-[15px]">
              不是只有惊天大案才算线索。一份被改过的报表、一次没有走完的审批流程、一个反复被压下来的投诉，都可能是入口。
            </p>
          </div>
          <a
            href="#submit-flow"
            className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap text-sm font-semibold text-primary-600 hover:text-primary-700"
          >
            看看怎么提交
            <i className="ri-arrow-down-line"></i>
          </a>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {leadTypes.map((item, index) => (
            <Reveal key={item.title} delay={index * 60}>
              <article className="group flex h-full flex-col rounded-lg border border-background-200 bg-background-100 p-6 transition-colors hover:border-primary-300 hover:bg-background-50">
                <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${item.icon} text-2xl`}></i>
                </span>
                <h3 className="mt-5 font-heading text-lg font-semibold text-foreground-950">{item.title}</h3>
                <p className="mt-3 flex-1 text-sm leading-7 text-foreground-600">{item.desc}</p>
                <div className="mt-5 flex flex-wrap gap-2">
                  {item.tags.map((tag) => (
                    <span
                      key={tag}
                      className="rounded-full bg-secondary-100 px-2.5 py-1 text-xs text-secondary-800"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}